import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import StorePrioritario from '../FormPrioritario/store'
import FormRelato from '../../components/FormRelato'
import FormItemPrioritario from '../../components/FormItemPrioritario'
import { CardForm } from '../../components/CardForm'
import { AccordionForm } from '../../components/AccordionForm'
import { Accordion } from 'semantic-ui-react'

export const PageFormRelato = () => {
  const { store, api } = StorePrioritario()
  const { id } = useParams<{ id: any }>()
  const [init, setInit] = useState(true)
  const [index, setIndex] = useState(-1)

  useEffect(() => {
    if (init) {
      setInit(false)
      api.get(id)
    }
  }, [api, id, init])

  return <CardForm
    requerAtencao={store?.requer_atencao}
    novo={store?.novo}
    titulo={store.titulo}
  >
    <Accordion>
      <AccordionForm
        activeIndex={index}
        index={0}
        onClick={e => setIndex(e)}
      >
        <FormItemPrioritario store={store} />
      </AccordionForm>
    </Accordion>

    <FormRelato item={store} />
  </CardForm>
}
